import { jsx as _jsx } from "react/jsx-runtime";
import { LabelTypeEnum } from '../../../types';
import { SSITypeLabelContainerStyled as Container } from '../../../styles/components';
import { backgroundColors, gradientColors } from '@sphereon/ui-components.core';
const getBackground = (type) => {
    switch (type) {
        case LabelTypeEnum.ISSUER:
            return gradientColors['200'];
        case LabelTypeEnum.VERIFIER:
            return gradientColors['100'];
        default:
            return backgroundColors.primaryLight;
    }
};
const SSITypeLabel = (props) => {
    const { type } = props;
    return _jsx(Container, { style: { background: getBackground(type) }, children: type });
};
export default SSITypeLabel;
